import React, { Dispatch, SetStateAction, useState, useEffect } from "react";
import { ManageFaqFilterContainer } from "../../Manage/ManageFaq/ManageFaqFilter";
import Flex from "../../../DefaultStyles/Flex";
import DropDown from "../../../Filters/DropDown";
import Search from "../../../Filters/Search";
import FilterIcon from "../../../DefaultStyles/FilterIcon";
import { LineBoxContainer } from "../../../../pages/UserLog/UserLog";
import CalendarLineBtn from "../../../Button/CalendarLineBtn";
import CalendarModal from "../../../Modal/CalendarModal";
import { CalendarLine } from "../ChatInfo/Old/OldRecentChat";
import ConfirmBtn from "../../../Button/ConfirmBtn";
import LineBtn from "../../../Button/LineBtn";
import { PartyInfoFilterContainer } from "../PartyInfo/PartyInfoFilter";
import UplusDataUploadModal from "../UplusMatchingInfo/UplusDataUploadModal";
import UplusMatchingStatusChangeModal from "../UplusMatchingInfo/UplusMatchingStatusChangeModal";

interface UplusMatchingInfoFilterProps {
  filter: {
    stateValue: string;
  };
  setFilter: Dispatch<
    SetStateAction<{
      searchType: string;
      searchValue: string;
      stateValue: string;
      startdate: string;
      enddate: string;
    }>
  >;
  pageResetEvent: () => void;
  fetchData: () => void;
  selectedResetEvent: () => void;
  selectedKey: { [key: number]: any };
  itemLength: number;
}

export default function OldUplusMatchingInfoFilter({
  filter,
  setFilter,
  fetchData,
  pageResetEvent,
  selectedKey,
  selectedResetEvent,
  itemLength,
}: UplusMatchingInfoFilterProps) {
  const [filterType, setFilterType] = useState({
    value: "",
    label: "선택",
  });
  const [searchValue, setSearchValue] = useState<string | undefined>("");
  const [startDate, setStartDate] = useState("날짜 선택");
  const [startDateClick, setStartDateClick] = useState(false);
  const [endDate, setEndDate] = useState("날짜 선택");
  const [endDateClick, setEndDateClick] = useState(false);
  const [upload, setUpload] = useState(false);
  const [status, setStatus] = useState({
    value: "",
    label: "결합 상태 선택",
  });
  const [selectStatusChangeModal, setSelectStatusChangeModal] = useState(false); // 선택 상태 변경 모달
  const [allStatusChangeModal, setAllStatusChangeModal] = useState(false); // 전체 상태 변경 모달

  const searchFilterTypeOption = [
    { value: "uid", label: "신청자 UID" },
    { value: "targetName", label: "등록 이름" },
    { value: "targetPhone", label: "등록 전화번호" },
    { value: "key", label: "Key" },
    { value: "admin", label: "관리자" },
  ];

  const matchStatusOption = [
    { value: "1", label: "매칭중" },
    { value: "2", label: "결합 대기" },
    { value: "3", label: "결합 완료" },
    { value: "4", label: "해지" },
    { value: "5", label: "결합 실패" },
    { value: "6", label: "매칭 취소" },
  ];

  useEffect(() => {
    if (searchValue && searchValue?.length > 0) {
      setFilter((prev) => ({
        ...prev,
        searchType: filterType?.value,
        searchValue: `${searchValue}`,
      }));
    }
  }, [searchValue]);

  return (
    <>
      <ManageFaqFilterContainer>
        <Flex gapSize={10}>
          <DropDown
            boxWidth={180}
            optionList={searchFilterTypeOption}
            dropdownValue={filterType}
            setDropDownValue={setFilterType}
          />

          <Search
            placeholder="입력"
            setSearchValue={setSearchValue}
            pageResetEvent={() => pageResetEvent()}
            isDisabled={filterType?.value === ""}
          />
        </Flex>

        <Flex gapSize={10}>
          <FilterIcon />
          {/* 결합 상태 선택 */}
          <DropDown
            boxWidth={180}
            dropdownValue={status}
            setDropDownValue={setStatus}
            optionList={matchStatusOption}
          />

          {/* 신청일 날짜 선택 */}
          <>
            <LineBoxContainer>
              <CalendarLineBtn
                onClickEvent={() => setStartDateClick(true)}
                value={startDate}
                initValue={"날짜 선택"}
                minWidth={155}
              />

              {startDateClick && (
                <CalendarModal
                  closeEvent={() => setStartDateClick(false)}
                  changeEvent={(date: string) => setStartDate(date)}
                  isFutureDisable={true}
                />
              )}
            </LineBoxContainer>

            <CalendarLine />

            <LineBoxContainer>
              <CalendarLineBtn
                onClickEvent={() => setEndDateClick(true)}
                value={endDate}
                initValue={"날짜 선택"}
                minWidth={155}
                disabled={startDate?.includes("선택")}
              />

              {endDateClick && (
                <CalendarModal
                  closeEvent={() => setEndDateClick(false)}
                  changeEvent={(date: string) => setEndDate(date)}
                  dateValue={startDate}
                  isAfterStartDate={true}
                />
              )}
            </LineBoxContainer>
          </>

          <ConfirmBtn
            btnText="적용"
            btnColor="mint"
            btnHeight={38}
            isDisabled={
              status?.value === "" &&
              (startDate?.includes("선택") || endDate?.includes("선택"))
            }
            btnClickEvent={() => {
              selectedResetEvent();
              pageResetEvent();
              setFilter((prev) => ({
                ...prev,
                stateValue: status?.value,
                startdate: startDate,
                enddate: endDate,
              }));
            }}
          />

          <LineBtn
            btnText="초기화"
            btnColor="mint"
            icon="refresh"
            btnHeight={38}
            disabled={
              status?.value === "" &&
              startDate?.includes("선택") &&
              endDate?.includes("선택")
            }
            btnClickEvent={() => {
              selectedResetEvent();
              setStartDate("날짜 선택");
              setEndDate("날짜 선택");

              setStatus({
                value: "",
                label: "결합 상태 선택",
              });
              setFilter((prev) => ({
                ...prev,
                stateValue: "",
                startdate: "",
                enddate: "",
              }));
            }}
          />
        </Flex>
      </ManageFaqFilterContainer>

      {filter?.stateValue !== "" && (
        <PartyInfoFilterContainer>
          <Flex gapSize={10}>
            {/* 매칭중 || 결합중 || 결합 완료 상태 */}
            {filter?.stateValue === "1" ||
            filter?.stateValue === "2" ||
            filter?.stateValue === "3" ? (
              <LineBtn
                btnText="선택 상태 변경"
                btnHeight={38}
                btnClickEvent={() => setSelectStatusChangeModal(true)}
                disabled={
                  Object.values(selectedKey)?.filter((a) => a !== null)
                    ?.length === 0 ||
                  itemLength === 0 ||
                  !itemLength
                }
              />
            ) : (
              <div />
            )}

            {/* 매칭중 상태 */}
            {filter?.stateValue === "1" ? (
              <LineBtn
                btnText="전체 상태 변경"
                btnHeight={38}
                btnClickEvent={() => setAllStatusChangeModal(true)}
                disabled={itemLength === 0 || !itemLength}
              />
            ) : (
              <div />
            )}
          </Flex>

          <div />
        </PartyInfoFilterContainer>
      )}

      {upload && (
        <UplusDataUploadModal
          closeEvent={() => setUpload(false)}
          confirmEvent={() => {
            fetchData();
          }}
        />
      )}

      {/* 선택 상태 변경 모달 */}
      {selectStatusChangeModal && (
        <UplusMatchingStatusChangeModal
          closeEvent={() => setSelectStatusChangeModal(false)}
          isSelect={true}
          type="input"
          nowStatus={Number(status?.value) ?? 0}
          selectedKey={Object.values(selectedKey)}
          confirmEvent={() => {
            selectedResetEvent();
            fetchData();
          }}
        />
      )}

      {/* 전체 상태 변경 모달 */}
      {allStatusChangeModal && (
        <UplusMatchingStatusChangeModal
          closeEvent={() => setAllStatusChangeModal(false)}
          type="input"
          nowStatus={1}
          confirmEvent={() => {
            selectedResetEvent();
            fetchData();
          }}
        />
      )}
    </>
  );
}
